<div id="dashboard-topbar" class="container-fluid" [ngClass]="{ active: (isOpenSidebar$ | async) }">
    <div class="row h-100 align-items-center justify-content-between">
        <div id="dashboard-topbar-left" class="col-auto">
            <a [ngClass]="{ 'd-none': (isOpenSidebar$ | async) !== false }" routerLink="/">
                <svg-icon [svgStyle]="{ 'width.px': 42 }" src="assets/images/logotyp_pekao.svg"> </svg-icon>
            </a>
        </div>
        <div id="dashboard-topbar-right" class="col-auto">
            <div class="me-1 me-md-4">
                <app-dashboard-layout-topbar-user
                    [representative]="currentRepresentative$ | async"></app-dashboard-layout-topbar-user>
            </div>
            <div class="me-1">
                <app-dashboard-layout-topbar-lang-change></app-dashboard-layout-topbar-lang-change>
            </div>
            <button appButtonIcon color="gray">
                <svg-icon src="assets/icons/Mail.svg"></svg-icon>
            </button>
            <div>
                <app-notification-settings></app-notification-settings>
            </div>
            <button
                id="logout-button"
                class="background-gradient-secondary animated"
                (click)="logout()"
                data-test="dashboard-topbar-logout">
                <svg-icon src="assets/icons/Logout.svg" svgClass="logout-icon"></svg-icon>
            </button>
        </div>
    </div>
</div>
